module.exports = __webpack_public_path__ + "img/audit_cover.5a7dd61.png";